import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';

const Portfolio = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: "Bloom Boutique",
      category: "social-media",
      description: "Complete social media revamp for a local flower shop, resulting in 150% increase in engagement.",
      image: "https://images.unsplash.com/photo-1487700160041-babef9c3cb55?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    },
    {
      id: 2,
      title: "Coastal Cafe",
      category: "branding",
      description: "Brand identity design for a beachside coffee shop, including logo, color palette, and packaging.",
      image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    },
    {
      id: 3,
      title: "Fitness First",
      category: "content",
      description: "Content creation for a fitness studio's Instagram, including workout videos and nutrition tips.",
      image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    },
    {
      id: 4,
      title: "Urban Eats",
      category: "website",
      description: "Website design and development for a food delivery service with online ordering functionality.",
      image: "https://images.unsplash.com/photo-1565299507177-b0ac66763828?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1622&q=80"
    },
    {
      id: 5,
      title: "Wanderlust Travel",
      category: "social-media",
      description: "Social media campaign for a travel agency, showcasing destinations and travel packages.",
      image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1621&q=80"
    },
    {
      id: 6,
      title: "Eco Essentials",
      category: "branding",
      description: "Brand identity for an eco-friendly product line, emphasizing sustainability and natural elements.",
      image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1613&q=80"
    },
    {
      id: 7,
      title: "Tech Innovations",
      category: "content",
      description: "Content strategy and creation for a tech startup's blog and social media channels.",
      image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
    },
    {
      id: 8,
      title: "Luxury Living",
      category: "website",
      description: "Website redesign for a luxury real estate agency with virtual tour integration.",
      image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG00by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1453&q=80"
    },
    {
      id: 9,
      title: "Artisan Bakery",
      category: "social-media",
      description: "Instagram strategy for an artisan bakery, showcasing their products and behind-the-scenes content.",
      image: "https://images.unsplash.com/photo-1517433670267-08bbd4be890f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80"
    }
  ];

  const filteredProjects = filter === 'all'
    ? projects
    : projects.filter(project => project.category === filter);

  return (
    <>
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-orange-50 to-white">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center"
          >
            <h1 className="mb-6 text-4xl font-bold md:text-6xl font-display">
              Our <span className="text-[#FF914D]">Portfolio</span>
            </h1>
            <p className="text-lg text-gray-600 md:text-xl">
              Explore our recent projects and see how we've helped businesses elevate their digital presence.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Portfolio Gallery */}
      <section className="section bg-white">
        <div className="container">
          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center mb-12 gap-3">
            {['all', 'social-media', 'branding', 'content', 'website'].map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-2 rounded-full transition-all duration-300 text-sm font-medium ${filter === category
                    ? 'bg-[#FF914D] text-white shadow-lg scale-105'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:scale-105'
                  }`}
              >
                {category === 'all' ? 'All Projects' :
                  category === 'social-media' ? 'Social Media' :
                    category === 'branding' ? 'Branding' :
                      category === 'content' ? 'Content Creation' : 'Website Design'}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <motion.div
            layout
            className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
          >
            <AnimatePresence>
              {filteredProjects.map((project) => (
                <motion.div
                  layout
                  key={project.id}
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.3 }}
                  className="group overflow-hidden bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300"
                >
                  <div className="relative overflow-hidden aspect-video">
                    <img
                      src={project.image}
                      alt={project.title}
                      className="object-cover w-full h-full transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                      <span className="text-white font-medium px-4 py-2 border border-white rounded-full">View Details</span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="mb-3">
                      <span className={`px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full ${project.category === 'social-media' ? 'bg-blue-100 text-blue-800' :
                          project.category === 'branding' ? 'bg-purple-100 text-purple-800' :
                            project.category === 'content' ? 'bg-green-100 text-green-800' :
                              'bg-yellow-100 text-yellow-800'
                        }`}>
                        {project.category.replace('-', ' ')}
                      </span>
                    </div>
                    <h3 className="mb-2 text-xl font-bold group-hover:text-[#FF914D] transition-colors">{project.title}</h3>
                    <p className="text-gray-600 line-clamp-3">{project.description}</p>
                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      {/* Case Studies Preview */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Featured Case Studies</h2>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
            {[
              {
                title: "Bloom Boutique: Social Media Transformation",
                description: "How we helped a local flower shop increase engagement by 150% and drive foot traffic to their store through strategic social media management.",
                image: "https://images.unsplash.com/photo-1487700160041-babef9c3cb55?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
                stats: [
                  { label: "Engagement Increase", value: "150%" },
                  { label: "Follower Growth", value: "200%" },
                  { label: "Revenue Impact", value: "+35%" }
                ]
              },
              {
                title: "Coastal Cafe: Brand Identity Redesign",
                description: "A complete brand overhaul for a beachside coffee shop that helped them stand out in a competitive market and attract a new customer demographic.",
                image: "https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80",
                stats: [
                  { label: "Brand Recognition", value: "+85%" },
                  { label: "Customer Retention", value: "+40%" },
                  { label: "Sales Growth", value: "+25%" }
                ]
              }
            ].map((study, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                className="overflow-hidden bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300"
              >
                <div className="relative overflow-hidden aspect-video">
                  <img
                    src={study.image}
                    alt={study.title}
                    className="object-cover w-full h-full"
                  />
                </div>
                <div className="p-8">
                  <h3 className="mb-3 text-2xl font-bold font-display">{study.title}</h3>
                  <p className="mb-6 text-gray-600">{study.description}</p>
                  <div className="grid grid-cols-3 gap-4 mb-6">
                    {study.stats.map((stat, idx) => (
                      <div key={idx} className="text-center p-3 bg-gray-50 rounded-lg">
                        <div className="text-2xl font-bold text-[#FF914D]">{stat.value}</div>
                        <div className="text-xs text-gray-500 uppercase tracking-wide mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                  <button className="flex items-center justify-center w-full px-4 py-3 text-[#FF914D] font-medium bg-white border-2 border-[#FF914D] rounded-lg hover:bg-[#FF914D] hover:text-white transition-all duration-300">
                    Read Full Case Study
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="section bg-white">
        <div className="container">
          <h2 className="section-title">Client Testimonials</h2>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            {[
              {
                quote: "Social Crouton transformed our social media presence. Their strategic approach and creative content have helped us connect with our audience in ways we never thought possible.",
                author: "Sarah Johnson",
                position: "Owner, Bloom Boutique",
                image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
              },
              {
                quote: "Working with Social Crouton on our brand identity was a game-changer. They captured the essence of our cafe and created a cohesive brand that resonates with our customers.",
                author: "Michael Rodriguez",
                position: "Founder, Coastal Cafe",
                image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
              },
              {
                quote: "The content created by Social Crouton has significantly increased our engagement and helped us establish ourselves as industry experts. Their team is creative, responsive, and a joy to work with.",
                author: "Jennifer Lee",
                position: "Marketing Director, Fitness First",
                image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
              }
            ].map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="p-8 bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-sm border border-gray-100"
              >
                <div className="mb-6 text-[#FF914D]">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                </div>
                <p className="mb-6 italic text-gray-600 leading-relaxed">{testimonial.quote}</p>
                <div className="flex items-center">
                  <div className="flex-shrink-0 mr-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.author}
                      className="object-cover w-12 h-12 rounded-full ring-2 ring-[#FF914D]/20"
                    />
                  </div>
                  <div>
                    <h4 className="font-bold text-dark">{testimonial.author}</h4>
                    <p className="text-sm text-gray-500">{testimonial.position}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-[#FF914D] to-[#FFB86B] text-white relative overflow-hidden">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10"></div>
        <div className="container text-center relative z-10">
          <h2 className="mb-6 text-4xl font-bold font-display">Ready to Transform Your Brand?</h2>
          <p className="max-w-2xl mx-auto mb-10 text-xl opacity-90">
            Let's create a digital strategy that elevates your brand and connects with your audience.
          </p>
          <Link
            to="/contact"
            className="inline-block px-8 py-4 text-lg font-bold text-[#FF914D] bg-white rounded-full shadow-xl hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            Start Your Project
          </Link>
        </div>
      </section>
    </>
  );
};

export default Portfolio;